module.exports = __webpack_public_path__ + "static/media/tradicional2.36b108c5.webp";